module.exports = __webpack_public_path__ + "static/media/circuit.8d16c4af.jpg";